module.exports = __webpack_public_path__ + "img/prioritas_sameday_k.1e2b8d3c.png";